/**
 * Public static assets served straight from object storage.
 *
 * These are fetched directly by the browser with plain (unsigned) URLs, so they
 * live in a public-read bucket — separate from the private app-data bucket that
 * user uploads go to via presigned URLs.
 *
 * Override the base with NEXT_PUBLIC_PUBLIC_ASSETS_BASE_URL to point at a
 * different bucket without a code change (useful while testing the migration).
 */
export const PUBLIC_ASSETS_BASE_URL =
  process.env.NEXT_PUBLIC_PUBLIC_ASSETS_BASE_URL ||
  "https://storage.googleapis.com/mple-public-assets";

/**
 * TEMPORARY: hardcoded to the pre-migration S3 copies.
 *
 * gs://mple-public-assets holds the same files at the same paths but is not
 * public-read yet (anonymous GET → 403 AccessDenied), which broke the speed
 * test and MediaPipe. The S3 objects are still public. Once the bucket grants
 * allUsers objectViewer, switch these back to PUBLIC_ASSETS_BASE_URL.
 */
const LEGACY_S3_PUBLIC_ASSETS_BASE_URL =
  "https://ai-roleplay-dev.s3.ap-south-1.amazonaws.com";

/** Small image used to sample download bandwidth. */
export const SPEED_TEST_IMAGE_URL = `${LEGACY_S3_PUBLIC_ASSETS_BASE_URL}/public/images/70451618316407074.png`;

/** MediaPipe FaceLandmarker runtime + model, loaded by ProfileLandmarkCapture. */
export const MEDIAPIPE_WASM_URL = `${LEGACY_S3_PUBLIC_ASSETS_BASE_URL}/public/models/wasm`;
export const MEDIAPIPE_FACE_LANDMARKER_MODEL_URL = `${LEGACY_S3_PUBLIC_ASSETS_BASE_URL}/public/models/face_landmarker.task`;
